
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        @Prop()
        public Item: Pregunta;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {

            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {

        }


        public Seleccionar( x: Pregunta )
        {
            this.Controlador.PreguntaSeleccionada = x;
            this.Controlador.Vista.Modo = 'pregunta';
        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => { this.Refresh = true; } );
        }
    }
